import { Grid, Typography } from "@mui/material"
import { StyledPaper } from "../components"
import { WalletsGroup } from '../assets/infographics'
import { ConnectButton } from "@rainbow-me/rainbowkit"

const ConnectBanner = () => {
  return (
    <Grid xs={12}>
      <StyledPaper color='primary' sx={{
        padding: { xs: '1rem', sm: '1.5rem 2rem' },
        minWidth: { xs: '100%' },
        maxWidth: { xs: '100%' },
        width: '100%',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}>
        <WalletsGroup />
        <Typography variant='body1' color='text.secondary'>
          CONNECT YOUR WALLET TO USE MEMELEND
        </Typography>
        <ConnectButton label="CONNECT WALLET" />
      </StyledPaper>
    </Grid>
  )
}

export default ConnectBanner